import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { May2520 } from 'src/staticSites/may25';

export const renderStaticSites = (root: HTMLElement) => {
  ReactDOM.render(
    <BrowserRouter>
      {getStaticSite()}
    </BrowserRouter>,
    root
  );
}
const getStaticSite = () => {
  switch (window.location.origin) {
    case process.env.REACT_APP_MAY25:
      return <May2520 />
    default:
      return null
  }
}


// WEBPACK FOOTER //
// ./src/staticSites/render.tsx